export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen pt-16 flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 text-primary-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>实时更新 · 不打烊</span>
            </div>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight tracking-tight">
              91黑料
              <span className="block text-primary-500">吃瓜爆料第一站</span>
            </h1>

            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-medium leading-relaxed">
              一手黑料 · 全网最快
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              91黑料网全天候追踪娱乐圈、网红圈与社交平台的最新爆料与吃瓜视频。从不打烊的网站入口到随时随地刷新的APP，我们为吃瓜群众提供最快、最全、最劲爆的黑料内容。无论是明星塌房、网红翻车还是社交平台热议话题，这里都是你获取第一手资讯的首选平台。当前站内已覆盖娱乐八卦、社会热点、直播翻车等多个内容板块，每日更新不停歇。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">24h</div>
                <div className="text-xs text-foreground-500 mt-1">全天候更新</div>
              </div>
              <div className="w-px h-10 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">10W+</div>
                <div className="text-xs text-foreground-500 mt-1">爆料内容覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">不打烊</div>
                <div className="text-xs text-foreground-500 mt-1">随时可访问</div>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </a>
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 border border-foreground-300 text-foreground-700 px-6 py-3 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-download-line"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20digital%20media%20art%20collage%20with%20glitch%20effect%20newspaper%20fragments%20social%20media%20icons%20in%20warm%20red%20crimson%20and%20charcoal%20dark%20tones%2C%20modern%20editorial%20design%20with%20bold%20graphic%20elements%2C%20dramatic%20contrast%20lighting%2C%20grunge%20texture%20overlay%2C%20cinematic%20mysterious%20atmosphere%2C%20breaking%20news%20aesthetic%2C%20clean%20minimal%20background%20with%20striking%20red%20accents&width=800&height=1000&seq=hero-visual-91hl&orientation=portrait"
                alt="91黑料吃瓜爆料平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2 text-white/90 text-xs">
                  <span className="bg-primary-500 px-2 py-0.5 rounded-full font-semibold">HOT</span>
                  <span>最新爆料实时更新中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}